<template>
  <div 
    class="loader-container"
    :class="{ 'full-title': fullTitle }"
    :style="{
      '--loader-size': size + 'rem',
      '--loader-color': color
    }"
  >
    <span class="letter first">{{ fullTitle ? 'out' : 'o' }}</span>
    <span class="letter second">{{ fullTitle ? 'talent' : 't' }}</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** Size in rem units (default: 2) */
  size?: number;
  /** Color of the loader (default: currentColor) */
  color?: string;
  /** Whether to show full "outtalent" text instead of "ot" */
  fullTitle?: boolean;
}

withDefaults(defineProps<Props>(), {
  size: 2,
  color: 'currentColor',
  fullTitle: false
});
</script>

<style scoped>
.loader-container {
  display: inline-flex;
  align-items: center;
  /* Use Inter or system font that supports variable font weights */
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: var(--loader-size);
  line-height: 1;
  color: var(--loader-color);
  /* Prevent layout shift */
  min-width: calc(var(--loader-size) * 1.2);
  height: var(--loader-size);
}

.loader-container.full-title {
  min-width: calc(var(--loader-size) * 7);
}

.letter {
  display: inline-block;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  /* Prevent selection during loading */
  user-select: none;
}

.first {
  animation-name: weightPulseFirst;
  /* Slight kerning adjustment */
  margin-right: -0.05em;
}

.second {
  animation-name: weightPulseSecond;
}

.full-title .first {
  margin-right: 0;
}

@keyframes weightPulseFirst {
  0%, 100% {
    font-variation-settings: 'wght' 600;
    opacity: 1;
  }
  50% {
    font-variation-settings: 'wght' 200;
    opacity: 0.7;
  }
}

@keyframes weightPulseSecond {
  0%, 100% {
    font-variation-settings: 'wght' 200;
    opacity: 0.7;
  }
  50% {
    font-variation-settings: 'wght' 600;
    opacity: 1;
  }
}
</style>
